import * as React from "react";
import {useTransition} from "react";
import {FilterSet, IntervalFilter, MenuNode, StaffUtilisationDataSet, ToShowFilter, UnitsFilter} from "./types.ts";
import {useForm} from "react-hook-form";

interface PropTypes {
    setFilters: React.Dispatch<React.SetStateAction<FilterSet>>,
    defaultFilters: FilterSet,
    staffScheduleOnly: boolean
}

export const UtilisationFilters = React.memo(function UtilisationFilters({defaultFilters, setFilters, staffScheduleOnly}: PropTypes) {
    const {register, getValues} = useForm<FilterSet>({
        defaultValues: defaultFilters
    });

    const [isPending, startTransition] = useTransition();
    return (
        <>
            <form onChange={(e) => {
                setTimeout(() => window.onbeforeunload = null, 600);
                setTimeout(() => startTransition(() => setFilters(getValues())), 2);
            }}
                  style={{position: 'relative'}}
            >
                {/*{isPending ? 'Loading' : ''}*/}
                <div className='d-flex gap-3 mb-2 align-items-end overflow-auto'
                     style={staffScheduleOnly ? {
                         flexWrap: 'wrap',
                         backgroundColor: 'white',
                         position: 'absolute',
                         width: '580px',
                         top: 0,
                         zIndex: '2'
                     }: {}}
                >
                    <div style={{minWidth: '27em'}}>
                        <div className="text-body-secondary mb-1 mt-1">Interval</div>
                        <div className="btn-group-sm" role="group" aria-label="">
                            <input type="radio" className="btn-check" id="daily"
                                   autoComplete="off" {...register('interval')} value="daily"/>
                            <label className="btn btn-outline-secondary" htmlFor="daily">Daily</label>
                        </div>
                        <div className="btn-group-sm" role="group" aria-label="">
                            <input type="radio" className="btn-check" {...register('interval')} id="weekly"
                                   autoComplete="off"
                                   value="weekly"/>
                            <label className="btn btn-outline-secondary" htmlFor="weekly">Weekly</label>
                        </div>
                        <div className="btn-group-sm" role="group" aria-label="">
                            <input type="radio" className="btn-check" {...register('interval')} id="fortnightly"
                                   autoComplete="off"
                                   value="fortnightly"/>
                            <label className="btn btn-outline-secondary" htmlFor="fortnightly">Fortnightly</label>
                        </div>
                        <div className="btn-group-sm" role="group" aria-label="">
                            <input type="radio" className="btn-check" {...register('interval')} id="monthly"
                                   autoComplete="off"
                                   value="monthly"/>
                            <label className="btn btn-outline-secondary" htmlFor="monthly">Monthly</label>
                        </div>
                    </div>

                    <div style={{minWidth: '43.5em'}}>
                        <div className="text-body-secondary mb-1 mt-1">Data to include</div>
                        <div className="btn-group-sm" role="group" aria-label="">
                            <input type="checkbox" className="btn-check" id="normalTasks" autoComplete="off"
                                   {...register('normalTasks')}
                            />
                            <label className="btn btn-outline-secondary" htmlFor="normalTasks">Normal Tasks</label>
                        </div>

                        <div className="btn-group-sm" role="group" aria-label="">
                            <input type="checkbox" className="btn-check" id="proposedTasks" autoComplete="off"
                                   {...register('proposedTasks')} />
                            <label className="btn btn-outline-secondary" htmlFor="proposedTasks">Proposed Tasks</label>
                        </div>

                        <div className="btn-group-sm" role="group" aria-label="">
                            <input type="checkbox" className="btn-check" id="prospectTasks" autoComplete="off"
                                   {...register('prospectTasks')} />
                            <label className="btn btn-outline-secondary" htmlFor="prospectTasks">Prospect Tasks</label>
                        </div>

                        <div className="btn-group-sm" role="group" aria-label="">
                            <input type="checkbox" className="btn-check" id="leave"
                                   autoComplete="off" {...register('leave')}/>
                            <label className="btn btn-outline-secondary" htmlFor="leave">Leave</label>
                        </div>

                        <div className="btn-group-sm" role="group" aria-label="">
                            <input type="checkbox" className="btn-check" id="overdue"
                                   autoComplete="off" {...register('overdueTasks')}/>
                            <label className="btn btn-outline-secondary" htmlFor="overdue">Overdue</label>
                        </div>
                    </div>
                    <div style={{minWidth: '12.5em'}}>
                        <div className="text-body-secondary mb-1 mt-1">Utilisation Data Units
                        </div>
                        <div className="btn-group-sm" role="group" aria-label="">
                            <input type="radio" className="btn-check" id="hours"
                                   autoComplete="off" {...register('units')} value="hours"/>
                        <label className="btn btn-outline-secondary" htmlFor="hours">Hours</label>
                        </div>

                        <div className="btn-group-sm" role="group" aria-label="">
                        <input type="radio" className="btn-check" {...register('units')} id="percent"
                               autoComplete="off"
                               value="percent"/>
                        <label className="btn btn-outline-secondary" htmlFor="percent">Percent</label>
                        </div>
                    </div>
                    <div style={{minWidth: '14.5em'}}>
                        <div className="text-body-secondary mb-1 mt-1">Base workload on Allocated hours or Forecast
                            at complete hours
                        </div>
                        <div className="btn-group-sm" role="group" aria-label="">
                        <input type="radio" className="btn-check" id="allocated"
                               autoComplete="off" {...register('allocatedForecast')} value="allocated"/>
                        <label className="btn btn-outline-secondary" htmlFor="allocated">Allocated</label>
                        </div>
                        <div className="btn-group-sm" role="group" aria-label="">
                        <input type="radio" className="btn-check" {...register('allocatedForecast')} id="forecast"
                               autoComplete="off"
                               value="forecast"/>
                        <label className="btn btn-outline-secondary" htmlFor="forecast">Forecast</label>
                        </div>
                    </div>
                    {staffScheduleOnly ? '' :
                        <div className="align-self-end flex-grow-1 d-flex justify-content-end" role="group"
                             aria-label="">
                            <div className="btn-group-sm ">
                                <input type="checkbox" className="btn-check" id="graph" autoComplete="off"
                                       {...register('graph')}
                                />
                                <label className="btn btn-outline-secondary" htmlFor="graph">Always Show Graph</label>
                            </div>
                        </div>
                    }
                </div>
            </form>
        </>
    )
})